var lib_core = require("lib-core");
var PadReplicatorData = require('./padReplicatorData.js');

var GenericPthPadGeneratorData = function (position, angle, totalNumberOfVerticalPads, totalNumberOfHorizontalPads, horizontalLeadToLeadPitch, verticalLeadToLeadPitch, pinPitch, motif) {
    PadReplicatorData.apply(this, arguments);
};

lib_core.inherit(GenericPthPadGeneratorData, PadReplicatorData);
lib_core.JsonParser.registerClass(GenericPthPadGeneratorData, "GenericPthPadGeneratorData");

module.exports = GenericPthPadGeneratorData;
